import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAuthSchedule} from '../services/getAuthSchedule';

export const useGetAuthScheduleQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.AUTH_SCHEDULE],
		queryFn: async ({signal}) => getAuthSchedule({signal}),
		enabled: false,
	});
